export default __webpack_public_path__ + "static/media/4.a06d7704.jpg";